import type { VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'vue';

import { cva } from 'class-variance-authority';

export { default as DefaultFilterSelect } from './FilterSelect.vue';

export type Item = string | number | boolean | Record<string, any>;
export type AcceptableValue = string | number | Record<string, any>;

export interface ClickedHighlightedItem<T = Item> {
	item: T;
	index: number;
}

export type DefaultFilterSelectVariant = 'primary' | 'dark';

export interface DefaultFilterSelectProps<T = Item> {
	title: string;
	class?: HTMLAttributes['class'];
	inputClasses?: HTMLAttributes['class'];
	items: T[];
	highlightedItems?: T[];
	getItemLabel?: (item: T) => string;
	filterFunction?: (val: T[], term: string) => T[];
	objectValue?: boolean;
	valueProp?: string;
	hideWhenDetached?: boolean;
	separatorVariant?: SeparatorHighlightedItemsVariant;
	isLoading?: boolean;
	variant?: DefaultFilterSelectVariant;
}

export const separatorHighlightedItemsVariant = cva('', {
	variants: {
		variant: {
			default: 'bg-primary-light-1',
			primary: 'bg-white-dark-2',
			dark: 'bg-primary-light-3'
		}
	},
	defaultVariants: {
		variant: 'primary'
	}
});

export type SeparatorHighlightedItemsVariant = VariantProps<
	typeof separatorHighlightedItemsVariant
>['variant'];
